import React from 'react';

import CreateTemplate from '../../Components/Create';
import { POR_PESO_VARIAVEL } from '../../utils';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

function transform({ nome, tipo, ...data }) {
  return {
    nome,
    tipo,
  };
}

const Create = (props) => (
  <CreateTemplate
    {...props}
    title="Nova Unidade de Produto"
    defaultValue={{ tipo: POR_PESO_VARIAVEL }}
    validate={validate}
    onFailure={Erros}
    transform={transform}
    isBack
  >
    <Form />
  </CreateTemplate>
);

export default Create;
